import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const marketWidgets = makeDynamicConfigWidgets([
  { name: 'marketDynamic', cols: 4 },
  { name: 'blog', cols: 8 },
]);
